import { render, staticRenderFns } from "./TgCjTitle.vue?vue&type=template&id=8284c340&"
import script from "./TgCjTitle.vue?vue&type=script&lang=js&"
export * from "./TgCjTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports